"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import dynamic from "next/dynamic";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster as AppToaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/context/auth-context";
import { SubscriptionProvider } from "@/lib/context/subscription-context";

// Firebase messaging is heavy — don't block the main app shell on it
const NotificationHandler = dynamic(
  () => import("@/components/notifications/notification-handler"),
  { ssr: false }
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 60 * 1000, // keep UI snappy across sidebar navigations
      gcTime: 5 * 60 * 1000,
    },
    mutations: {
      retry: 0, // Don't retry mutations (create/update/delete)
    },
  },
});

export default function Providers({ children }: { children: any }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <SubscriptionProvider>
          <TooltipProvider>
            <AppToaster />
            <Sonner />
            <NotificationHandler />
            {children}
          </TooltipProvider>
        </SubscriptionProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}
